// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import axios from "axios"
import VueQuillEditor from 'vue-quill-editor'

import Header from './Header'
import Slider from './Slider'
import App from './App'


import Home from './components/Home'
import Danwei from './components/Danwei'
import Cheliang from './components/Cheliang'
import Xueyuan from './components/Xueyuan'
import ZXueyuan from './components/ZXueyuan'
import Notfound from './components/Notfound'

import Text from './components/Text'
import Edit from './components/Edit'
import Addt from './components/Addt'

import Info from './components/Info'
import Einfo from './components/Einfo'
import Addi from './components/Addi'

import Exam from './components/Exam'
import Eexam from './components/Eexam'
import Sexam from './components/Sexam'

import Examall from './components/Examall'
import Textall from './components/Textall'

import Sh from './components/Sh'
import Yh from './components/Yh'


import Admin from './components/Admin'
import Login from './components/Login'

import {store} from './store/store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueQuillEditor)

Vue.prototype.$ajax = axios;

//设置路由
const router = new VueRouter({
	mode:"history",
	base:__dirname,
	routes:[
		{path:"/",component:Login},
		{path:"/home",component:Home},
		{path:"/dw",component:Danwei},
		{path:"/cl",component:Cheliang},
		{path:"/ry",component:Xueyuan},
		{path:"/xy",component:ZXueyuan},
		{path:"/text",component:Text},
		{path:"/textall",component:Textall},
		{path:"/addt",component:Addt},
		{path:"/edit:id",component:Edit},
		{path:"/sh",component:Sh},
		{path:"/yh",component:Yh},
		{path:"/exam",component:Exam},
		{path:"/examall",component:Examall},
		{path:"/eexam:id",component:Eexam},
		{path:"/sexam",component:Sexam},
		{path:"/admin",component:Admin},
		{path:"/info",component:Info},
		{path:"/addi",component:Addi},
		{path:"/einfo:id",component:Einfo},
		{path: '*', component: Notfound}
	]
})

router.beforeEach((to, from, next) => {
	NProgress.start(); // 开启Progress
	if(store.getters.token){
		if (store.getters.name == 'admin') {
			if(to.path=='/admin' || to.path=='/xy' || to.path=='/text' || to.path=='/exam' || to.path=='/addt'|| to.path.indexOf('/edit')>-1 || to.path.indexOf('/eexam')>-1 ) next();
			else next('/admin');
		} else {
			if(to.path=='/' || to.path=='/admin' || to.path=='/xy') next('/home');
			else next();
		}
	}else{
		if(to.path=='/') next();
		else next('/');
	}
})

router.afterEach((to) => {
	store.state.activeIndex = to.path.substring(1);
	NProgress.done(); // 结束Progress
})

/* eslint-disable no-new */
new Vue({
	store:store,
	router,
	computed: { 
        paths() {  
            return this.$route.path != "/";
        }
	},
	components:{
		App,
		Header,
		Slider
	},
	template:`
	<div id="app">
	<app></app>
	<router-view v-if="!paths"></router-view>
	<el-container v-if="paths">
	  <el-header>
	  	<Header></Header>
	  </el-header>

	  <el-container>

	    <el-aside v-if="paths" width="150px">
	    	<slider></slider>
	    </el-aside>

	    <el-container>
	      <el-main>
	      	<router-view></router-view>
	      </el-main>

	      <el-footer height="20px">
	      	ELF © 2018 Powered by Shell
	      </el-footer>
	    </el-container>

	  </el-container>
	</el-container>
		
	</div>`
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js